import React, { memo } from "react";
import { Box, LogoSimple, LogoDefault } from "@pochta/ui";

var Logo = function Logo(_ref) {
  var isMobile = _ref.isMobile,
      mobileCentered = _ref.mobileCentered;
  return /*#__PURE__*/React.createElement(Box, {
    textAlign: mobileCentered && isMobile ? "center" : "left"
  }, isMobile ? /*#__PURE__*/React.createElement(LogoSimple, {
    variant: "modern",
    width: 119,
    height: 17
  }) : /*#__PURE__*/React.createElement(LogoDefault, {
    variant: "modern",
    width: 120,
    height: 60
  }));
};

export default /*#__PURE__*/memo(Logo);